export const categories = [
  {
    id: 'rumen',
    name: '新手入门',
    slug: 'rumen',
    description: '从零开始了解抖ying，掌握注册登录、账号设置等基础操作',
    icon: 'ri-user-add-line',
    articleCount: 12,
  },
  {
    id: 'neirong',
    name: '内容创作',
    slug: 'neirong',
    description: '学习短视频拍摄剪辑、选题策划、爆款内容打造技巧',
    icon: 'ri-movie-line',
    articleCount: 18,
  },
  {
    id: 'yunying',
    name: '运营技巧',
    slug: 'yunying',
    description: '掌握账号运营策略、粉丝互动、数据分析和平台规则',
    icon: 'ri-line-chart-line',
    articleCount: 15,
  },
  {
    id: 'bianxian',
    name: '流量变现',
    slug: 'bianxian',
    description: '探索直播带货、广告合作、电商变现等多元盈利模式',
    icon: 'ri-money-cny-circle-line',
    articleCount: 14,
  },
  {
    id: 'suanfa',
    name: '算法解析',
    slug: 'suanfa',
    description: '深入理解抖ying推荐算法机制，提升内容曝光和流量获取',
    icon: 'ri-brain-line',
    articleCount: 10,
  },
  {
    id: 'qiye',
    name: '企业号运营',
    slug: 'qiye',
    description: '企业蓝V认证、品牌营销策略、企业号专属功能详解',
    icon: 'ri-building-line',
    articleCount: 8,
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});